import styled from 'styled-components';
import { Button } from 'components/Button';

export const NftMediaIconWrapper = styled(Button)`
  &&&& {
    position: absolute;
    z-index: 10;
    right: 24px;
    top: 24px;
    padding: 0px;
    justify-content: center;
    height: 48px;
    width: 48px;
  }
`;
